import { render, staticRenderFns } from "./bussinessArea.vue?vue&type=template&id=2eab6683&scoped=true"
import script from "./bussinessArea.vue?vue&type=script&lang=js"
export * from "./bussinessArea.vue?vue&type=script&lang=js"
import style0 from "./bussinessArea.vue?vue&type=style&index=0&id=2eab6683&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eab6683",
  null
  
)

export default component.exports